import API_URL from "../const";

/**
 * Genera un ID único por evento. Es la clave para que Meta deduplique el evento
 * recibido por el navegador (Pixel) y por el servidor (Conversions API).
 */
export const generateEventId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `evt-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

// Lee una cookie por nombre (o null si no existe).
const getCookie = (name) => {
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)"),
  );
  return match ? decodeURIComponent(match[1]) : null;
};

/**
 * Recupera las cookies de Meta (_fbp y _fbc) que mejoran el emparejamiento.
 * Si no existe _fbc pero la URL trae ?fbclid=..., lo construye según el formato de Meta.
 */
const getFbCookies = () => {
  const fbp = getCookie("_fbp");
  let fbc = getCookie("_fbc");

  if (!fbc) {
    const fbclid = new URLSearchParams(window.location.search).get("fbclid");
    if (fbclid) {
      fbc = `fb.1.${Date.now()}.${fbclid}`;
    }
  }

  return { fbp, fbc };
};

/**
 * Dispara un evento estándar de Meta simultáneamente en:
 *   1) el navegador (Pixel / fbq) — con { eventID } para habilitar la deduplicación
 *   2) el servidor (Conversions API vía api/send_meta_event.php)
 * usando el MISMO event_id, de modo que Meta no duplique la conversión.
 *
 * @param {string} eventName  Evento estándar: "Lead", "CompleteRegistration", "PageView"...
 * @param {object} [options]
 * @param {string} [options.email]       Correo en texto plano (el servidor lo hashea).
 * @param {string} [options.phone]       Teléfono en texto plano (el servidor lo hashea).
 * @param {object} [options.customData]  Datos adicionales, p.ej. { content_name: "Contacto" }.
 * @returns {string} El event_id generado.
 */
export const trackMetaEvent = (
  eventName,
  { email = "", phone = "", customData = {} } = {},
) => {
  const eventId = generateEventId();
  const { fbp, fbc } = getFbCookies();

  // 1) Navegador (Pixel). El 4.º argumento { eventID } es lo que permite deduplicar.
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", eventName, customData, { eventID: eventId });
  }

  // 2) Servidor (Conversions API). Fire-and-forget; keepalive para que sobreviva a la navegación.
  fetch(`${API_URL}send_meta_event.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    keepalive: true,
    body: JSON.stringify({
      event_name: eventName,
      event_id: eventId,
      email,
      phone,
      fbp,
      fbc,
      event_source_url: window.location.href,
      custom_data: customData,
    }),
  }).catch((err) => console.error("Error Meta CAPI:", err));

  return eventId;
};
